// extracted by mini-css-extract-plugin
export default {"container":"_LKcfj","quote":"Hr01e4"};